var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5301",
    "data-name": "Group 5301",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_261",
    "data-name": "Ellipse 261",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e3ebf1",
    strokeWidth: 1,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "noun-cards-510550",
    transform: "translate(6.022 8.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12456",
    "data-name": "Path 12456",
    d: "M111.126,99.677a1.908,1.908,0,0,0-.088-.554l-2.028-6.157-.948-2.874a1.76,1.76,0,0,0-1.663-1.211,1.834,1.834,0,0,0-.554.088l-4.377,1.444a1.76,1.76,0,0,0-1.211,1.663,1.834,1.834,0,0,0,.088.554l2.991,9.045a1.745,1.745,0,0,0,2.2,1.109l4.392-1.444a1.752,1.752,0,0,0,1.2-1.663Zm3.808-12.78,4.377,1.444a3.918,3.918,0,0,1,2.714,3.735,4.088,4.088,0,0,1-.2,1.24l-2.977,9.031a3.949,3.949,0,0,1-4.96,2.524l-3.837-1.255-3.823,1.255a3.971,3.971,0,0,1-4.975-2.509l-2.977-9.046a4.018,4.018,0,0,1-.2-1.24,3.931,3.931,0,0,1,2.714-3.735l4.377-1.444a4.09,4.09,0,0,1,1.24-.2,3.924,3.924,0,0,1,3.648,2.495,3.929,3.929,0,0,1,3.662-2.495,3.609,3.609,0,0,1,1.225.2ZM111.2,92.615l1.926,5.836a3.91,3.91,0,0,1,.19,1.225,3.952,3.952,0,0,1-.846,2.436l2.086.686a1.722,1.722,0,0,0,.54.073,1.746,1.746,0,0,0,1.678-1.211l2.976-9.016a2.083,2.083,0,0,0,.088-.569,1.728,1.728,0,0,0-1.211-1.663l-4.377-1.444a1.742,1.742,0,0,0-.54-.088,1.8,1.8,0,0,0-1.678,1.2Z",
    transform: "translate(-98.068 -86.692)",
    fill: "#7d6aeb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCards);
export default __webpack_public_path__ + "static/media/totalCards.b5ada682ca83a832abb989a8259c5eaa.svg";
export { ForwardRef as ReactComponent };